export default {
    '系统繁忙，请稍后重试': '系统繁忙，请稍后重试',
    该应用没有保存图片的权限: '该应用没有保存图片的权限',
};
